module.exports = __webpack_public_path__ + "static/Sonyax5e-f434c21b403e250c05968363b43b6107.png";